import { call, post } from "@/services/api";

// His `camreq`: a PC asks the tablet in "📱 Photo station" mode for photos.
export type CameraRequest = {
  id: number; mode: "media" | "rec"; myotaku_event_id: number | null; run_id: number | null; item_key: string | null;
  label: string | null; status: "open" | "taken" | "closed"; photo_count: number; at: string;
  // The list the PC showed when it asked for a job not started: the run its first photo makes is ticked in it.
  from_orders?: boolean | null;
};

export const fetchStationRequests = () => call<{ requests: CameraRequest[] }>(`/api/v1/camera_requests`);
export const fetchCameraRequest = (id: number) => call<CameraRequest>(`/api/v1/camera_requests/${id}`);
// A job's photos name its run, or — before the job has one — its planning entry (`event_id`) and the list
// shown (`from_orders`): the request makes nothing, the tablet's first photo makes the run.
export const askTablet = (b: { mode: "media" | "rec"; run_id?: number | null; event_id?: number | null; from_orders?: boolean; item_key?: string | null; label: string }) =>
  post<CameraRequest>(`/api/v1/camera_requests`, b);
export const countTabletPhoto = (id: number) => post<CameraRequest>(`/api/v1/camera_requests/${id}/photo`);
export const takeTabletRequest = (id: number) => post<CameraRequest>(`/api/v1/camera_requests/${id}/taken`);
export const closeTabletRequest = (id: number) => post<CameraRequest>(`/api/v1/camera_requests/${id}/close`);
